<template>
  <div class="Dashbord" ref="document">
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="true"
        :is-full-page="fullPage"
        color="#018389"
        loader="dots"
      ></loading>
    </div>
    <!-- color="#fffff" -->
    <div class="Actions__Content" style="padding: 10px">
      <div class="DataTable">
        <div fluid style="padding-top: 10px; padding-bottom: 10px">
          <v-layout
            row
            wrap
            style="padding-top: 0px !important; max-height: 1000px !important"
          >
            <v-flex
              xs2
              pa-2
              style="
                padding-top: 0px !important;
                padding-bottom: 0px !important;
              "
            >
              <v-menu
                ref="menuOd"
                v-model="menuOd"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="dateFormattedOd"
                  label="Datum od"
                  readonly
                  @blur="dateOd = parseDate(dateFormattedOd)"
                ></v-text-field>
                <v-date-picker
                  v-model="dateOd"
                  no-title
                  @input="menuOd = false"
                  :max="maxDate"
                ></v-date-picker>
                <v-btn
                  text
                  color="primary"
                  @click="
                    dateOd = null;
                    $refs.menuOd.save([]);
                  "
                  >Poništi izbor
                </v-btn>
              </v-menu>
            </v-flex>
            <v-flex
              xs2
              pa-2
              style="
                padding-top: 0px !important;
                padding-bottom: 0px !important;
              "
            >
              <v-menu
                ref="menuDo"
                v-model="menuDo"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="dateFormattedDo"
                  label="Datum do"
                  readonly
                  @blur="dateDo = parseDate(dateFormattedDo)"
                ></v-text-field>
                <v-date-picker
                  v-model="dateDo"
                  no-title
                  @input="menuDo = false"
                  :max="maxDate"
                ></v-date-picker>
                <v-btn
                  text
                  color="primary"
                  @click="
                    dateDo = null;
                    $refs.menuDo.save([]);
                  "
                  >Poništi izbor
                </v-btn>
              </v-menu>
            </v-flex>
            <v-flex
              xs7
              pa-2
              style="
                padding-top: 0px !important;
                padding-bottom: 0px !important;
              "
            >
            </v-flex>
            <v-flex xs1 style="text-align: right">
              <v-btn
                @click="submit"
                class="AppButtonFilled"
                style="margin-top: 15px"
                >Pretraži</v-btn
              >
            </v-flex>
          </v-layout>
          <v-form ref="form">
            <v-layout
              row
              wrap
              style="padding-top: 0px !important; max-height: 1000px !important"
            >
              <v-flex
                xs5
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
                <v-autocomplete
                  v-model="wt_select"
                  :items="wt_items"
                  item-text="name"
                  item-value="id"
                  label="Tip vina"
                  persistent-hint
                  return-object
                  multiple
                  chips
                  deletable-chips
                  hide-no-data
                  clearable
                  v-on:change="changeRouteTipVina"
                  outlined
                  dense
                >
                </v-autocomplete>
              </v-flex>
              <v-flex
                xs6
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
                <v-autocomplete
                  v-model="wine_select"
                  :items="wine_items"
                  :item-text="getFieldTextWine"
                  item-value="id"
                  label="Vino u tanku"
                  persistent-hint
                  return-object
                  multiple
                  chips
                  deletable-chips
                  hide-no-data
                  clearable
                  outlined
                  dense
                >
                </v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
              style="padding-top: 0px !important; max-height: 1000px !important"
            >
              <v-flex
                xs11
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
                <v-autocomplete
                  v-model="actions_select"
                  :items="actions_item"
                  item-text="name"
                  item-value="id"
                  label="Operacija"
                  persistent-hint
                  return-object
                  multiple
                  chips
                  deletable-chips
                  hide-no-data
                  clearable
                  outlined
                  dense
                >
                </v-autocomplete>
              </v-flex>

              <v-flex
                xs1
                style="
                  text-align: center;
                  margin-bottom: 0px;
                  padding-left: 30px;
                "
              >
                <!-- <download-excel
                :data="json_data"
                :fields="json_fields"
                :meta="json_meta"
                :name="naziv_fajla"
                :param="json_fields"
              >
                <img
                  src="../assets/menuIcons/ico-print.png"
                  title="Štampa dokumenta"
                />
              </download-excel> -->

                <v-btn @click="stampaj" fab small
                  ><img
                    src="../assets/menuIcons/ico-print.png"
                    title="Štampa dokumenta"
                /></v-btn>
              </v-flex>
            </v-layout>
          </v-form>
          <div>
            <p
              style="
                width: 97%;
                text-align: right;
                color: grey;
              "
            >
            * označava vina koja se koriste samo u proizvodnji
            </p>
          </div>
          <v-layout
            row
            wrap
            style="
              max-height: 100% !important;
              padding-top: 0px !important;
              padding-bottom: 0px !important;
            "
          >
            <v-flex
              xs12
              pa-2
              style="
                padding-top: 0px !important;
                padding-bottom: 0px !important;
              "
            >
              <v-data-table
                :headers="headers_states"
                :items="items_states"
                class="TankTable"
                item-key="tpwId"
                ref="dTable"
                :pagination.sync="paginationKartica"
                :total-items="ukupnoRedova"
                :rows-per-page-items="listSize"
                style="padding-top: 10px"
                expand
                fixed-header
                hide-actions
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th
                      style="padding-left: 5px; padding-right: 5px"
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="[
                        'column sortable',
                        paginationKartica.descending ? 'desc' : 'asc',
                        header.value === paginationKartica.sortBy
                          ? 'active'
                          : '',
                        header.align === 'left'
                          ? 'text-xs-left'
                          : header.align === 'right'
                          ? 'text-xs-right'
                          : 'text-xs-center',
                      ]"
                      @click="changeSortKartica(header.value)"
                    >
                      <v-icon small v-if="header.sortable !== false"
                        >arrow_upward</v-icon
                      >
                      {{ header.text }}
                    </th>
                  </tr>
                </template>

                <template slot="items" slot-scope="props">
                  <tr>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.no }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ formatDateTime(props.item.date) }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ prevediSveOperacijeLok(props.item.operation) }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.wineType }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.wine + (props.item.inProduction ? ' *' : '') }}
                    </td>
                    
                    <td
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        props.item.outage !== null && props.item.outage !== 0
                          ? props.item.outage +
                            " " +
                            props.item.outageUnitOfMeasure
                          : "-"
                      }}
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        props.item.sediment !== null &&
                        props.item.sediment !== 0
                          ? props.item.sediment +
                            " " +
                            props.item.sedimentUnitOfMeasure
                          : "-"
                      }}
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        props.item.pressingRest !== null &&
                        props.item.pressingRest !== 0
                          ? props.item.pressingRest +
                            " " +
                            props.item.pressingRestUnitOfMeasure
                          : "-"
                      }}
                    </td>
                    <!-- <td>
                          <img
                                    class="DataTable__Button"
                                    title="Pregled operacije"
                                    src="../assets/icons/zatabele/ico-view.png"
                                    alt="ulaz-grozdja"
                                    @click="viewItem(props.item, false)"
                                    v-if="props.item.operation !== 'CHANGE_WINE' && props.item.operation !== 'CHANGE_PHASE' && props.item.measurementType === null"
                                  />
                        </td> -->
                  </tr>
                </template>
                <template slot="footer">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td style="text-align: center">Ukupno:</td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-if="total.rastur !== 0"
                  >
                    {{ total.rastur }} l
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else
                  >
                    -
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-if="total.talog !== 0"
                  >
                    {{ total.talog }} l
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else
                  >
                    -
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-if="total.komina !== 0"
                  >
                    {{ total.komina }} kg
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else
                  >
                    -
                  </td>
                </template>
                <template slot="no-data">
                  <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="primary"
                    icon="info"
                    >Nema podataka.</v-alert
                  >
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </div>
  </div>
</template>

        <script>
import { serverBus } from "../main";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TokenComponent from "../components/Token";

import html2pdf from "html2pdf.js";

import {
  readJSON,
  prevediSveOperacijeSaSrpskog,
  prevediSveOperacije,
  getDateTime,
} from "../helpers/Functions";
//import { valueToRelative } from "@amcharts/amcharts4/.internal/core/utils/Utils";

export default {
  props: ["operationType"],
  name: "Maka",
  dialog: false,
  components: {
    TokenComponent,
    Loading,
  },
  data() {
    return {
      json_fields: {},
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      isLoading: false,
      fullPage: true,
      headers_states: [
        { text: "Rb." },
        { text: "Datum", value: "date", align: "center", sortable: true },
        {
          text: "Operacija",
          value: "operation",
          align: "center",
          sortable: true,
        },
        {
          text: "Tip vina",
          value: "wineType",
          align: "center",
          sortable: true,
        },
        {
          text: "Vino",
          value: "wine",
          align: "center",
          sortable: true,
        },
        {
          text: "Rastur",
          value: "outage",
          align: "right",
          sortable: true,
        },
        {
          text: "Talog",
          value: "sediment",
          align: "right",
          sortable: true,
        },
        {
          text: "Komina",
          value: "pressing_rest",
          align: "right",
          sortable: true,
        },
        // ,{
        //   text: "",
        //   sortable: false
        // }
      ],
      items_states: [],
      listSize: [
        { text: "5", value: 5 },
        { text: "10", value: 10 },
        { text: "25", value: 25 },
        { text: "50", value: 50 },
        { text: "100", value: 100 },
        { text: "Svi", value: 1000000 },
      ],
      paginationKartica: {
        sortBy: "date",
        descending: true,
        rowsPerPage: 1000000,
        descending: true,
        current: 1,
        page: 1,
      },
      redovaPoStrani: 25,
      ukupnoRedova: 0,
      search: "",
      izabranaStranica: 0,

      operation_to_select: undefined,

      loading: true,
      total: {
        rastur: 0,
        talog: 0,
        komina: 0,
      },
      naziv_fajla: "",
      naslov: "",

      filterOperacija: "",
      filterEtiketa: "",
      fiterTipoviVina: "",

      json_fields_type: [],
      room_to_select: undefined,
      tank_select: undefined,

      datumOdFiter: "",
      datumDoFiter: "",

      menuOd: "",
      dateOd: null,
      dateFormattedOd: null,
      menuDo: "",
      dateDo: null,
      dateFormattedDo: null,

      actions_item: [
        {
          id: 1,
          name: "Ulaz grožđa",
        },
        {
          id: 10,
          name: "Presovanje",
        },
        {
          id: 2,
          name: "Pretakanje",
        },
        {
          id: 3,
          name: "Kupažiranje",
        },
        {
          id: 4,
          name: "Filtriranje",
        },
        {
          id: 5,
          name: "Mešanje",
        },
        {
          id: 6,
          name: "Dolivanje",
        },
        {
          id: 7,
          name: "Flaširanje",
        },
        {
          id: 8,
          name: "Dodavanje",
        },
        {
          id: 9,
          name: "Merenje",
        },
        {
          id: 11,
          name: "Istakanje",
        },
      ],
      actions_select: undefined,
      wine_select: undefined,
      year_select: undefined,
      wt_select: undefined,
      wt_items: [],
      wine_items: [],
    };
  },
  computed: {
    pages() {
      

      if (
        this.paginationKartica.rowsPerPage == null ||
        this.ukupnoRedova == null
      )
        return 0;

      return Math.ceil(this.ukupnoRedova / this.paginationKartica.rowsPerPage);
    },
    maxDate() {
      const today = new Date();
      // const dd = today.getUTCDate();
      return this.formatDate(today);
    },
    params(nv) {
      return {
        ...this.paginationKartica,
        query: this.search,
      };
    },
  },
  watch: {
    operationType: function (val) {
      this.clear();

      if (val !== null && val !== undefined) {
        this.getAllVina(true);

        this.getAllWineTypes();
      }
    },
    dateOd(val) {
      this.dateFormattedOd = this.formatDate1(this.dateOd);
    },
    dateDo(val) {
      this.dateFormattedDo = this.formatDate1(this.dateDo);
    },
    params: {
      handler(newVal, oldVal) {
        if (this.operationType !== undefined)
          if (
            (newVal.page !== oldVal.page ||
              newVal.rowsPerPage !== oldVal.rowsPerPage ||
              newVal.sortBy !== oldVal.sortBy ||
              newVal.descending !== oldVal.descending) &&
            newVal.sortBy !== ""
          ) {
            if (
              (newVal.sortBy === "date" && oldVal.sortBy === "plant_date") ||
              (newVal.sortBy === "plant_date" && oldVal.sortBy == "date")
            ) {
            } else {
              this.izabranaStranica = this.paginationKartica.page - 1;

              if (newVal.sortBy === "operation") this.getAllVina(true, true);

              if (this.wt_items.length === 0) {
                this.getAllWineTypes();
              }
            }
          }
      },
      deep: true,
    },
  },

  methods: {
    getAllWineTypes() {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/wine_type/all", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          // // console.log(response.data);

          this.wt_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/wine_type/all",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.wt_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getFieldTextWine(item) {
      let response = "";

      if (item.length === undefined)
        if (item.wineLabel !== undefined)
          response = `${item.wineLabel.name} ${item.year} ${item.wineLabel.inProduction ? '*' : ''}`;

      return response;
    },
    setDate() {
      const today = new Date();
      let Year = `${today.getFullYear()}`;
      let Month = `${today.getMonth() + 1}`;
      let Day = `${today.getDate()}`;

      if (Month.length < 2) Month = `0${Month}`;
      if (Day.length < 2) Day = `0${Day}`;

      this.dateOd = [Year, Month, "01"].join("-");
      this.dateDo = [Year, Month, Day].join("-");
    },
    viewItem(item) {
      

      let akcija = 0;

      if (item.operation === "GRAPE_INPUT") akcija = 1;
      else if (item.operation === "DECANTING") akcija = 2;
      else if (item.operation === "PRESSING") akcija = 10;
      else if (item.operation === "BLENDING") akcija = 3;
      else if (item.operation === "FILTERING") akcija = 4;
      else if (item.operation === "MIXING") akcija = 5;
      else if (item.operation === "FILLING") akcija = 6;
      else if (item.operation === "BOTTLING") akcija = 7;
      else if (item.operation === "ADDING") akcija = 8;
      else if (item.operation === "MEASURING") akcija = 9;
      else if (item.operation === "EMPTYING") akcija = 11;

      serverBus.$emit(
        "open_modal_prerada",
        akcija,
        prevediSveOperacije(item.operation),
        item
      );
    },
    prevediSveOperacijeLok(tekst) {
      return prevediSveOperacije(tekst);
    },
    currencyFormatDE(num) {
      return num
        .toFixed(2) // always two decimal digits
        .replace(".", ",") // replace decimal point character with ,
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."); // use . as a separator
    },
    formatInt(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");

      return `${day}.${month}.${year}`;
    },
    formatDateTime(date) {
      if (date !== undefined && date !== null) {
        let lokDate = date.split("T")[0];
        let lokTime = date.split("T")[1];

        let month = lokDate.split("-")[1];
        let day = lokDate.split("-")[2];
        const year = lokDate.split("-")[0];

        let HH = lokTime.split(":")[0];
        let mm = lokTime.split(":")[1];

        return [day, month, year].join(".") + " " + [HH, mm].join(":");
      } else return "";
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.paginationKartica.page = 1;

        this.getAllVina(true);
      }
    },
    changeRouteTipVina(a) {
      this.getAllVinaSifarnik(a);
    },
    getAllVinaSifarnik(a) {
      // if (a.length > 0) {
      let pom_operation_to_to_select = "";

      if (a !== undefined)
        a.forEach(function (entry) {
          pom_operation_to_to_select =
            pom_operation_to_to_select + "wineTypeId=" + entry.id + "&";
        });

      let url = "/wine/all";
      if (pom_operation_to_to_select !== "")
        url =
          url +
          "?" +
          pom_operation_to_to_select.substring(
            0,
            pom_operation_to_to_select.length - 1
          );

      this.$http
        .get(this.globalServiceLocation + this.globalPort + url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          //// // console.log(response.data);

          this.wine_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(this.globalServiceLocation + this.globalPort + url, {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization:
                          "Bearer  " + localStorage.getItem("user-token"),
                      },
                    })
                    .then((response) => {
                      //// // console.log(response.data);

                      this.wine_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
      // } else {
      //   this.wine_items = [];
      //   this.wine_select = [];
      // }
    },
    getAllVina(paginacija, sortiranjeOperacije) {
      this.isLoading = true;

      this.naziv_fajla = "vino_u_tankovima.xls";
      this.naslov = "Pregled rastura, taloga i komine";

      this.json_fields = {
        Rb: "String",
        Datum: "Date",
        Operacija: "String",
        "Tip vina": "String",
        Vino: "String",
        Rastur: "String",
        Talog: "String",
        Komina: "String",
      };

      this.json_fields_type = [
        "String",
        "Date",
        "String",
        "String",
        "String",
        "Number",
        "Number",
        "Number",
      ];

      let _this = this;

      let strDate = "";
      if (this.dateOd !== null) {
        strDate = "&from=" + this.dateOd + "T00:00";
        this.datumOdFiter = this.dateOd;
      }

      let strDateDo = "";
      if (this.dateDo !== null) {
        strDateDo = "&to=" + this.dateDo + "T23:59";
        this.datumDoFiter = this.dateDo;
      }

      var pom_etiketa = "";
      this.filterEtiketa = "";

      if (this.wine_select !== undefined && this.wine_select !== null) {
        this.wine_select.forEach(function (entry) {
          pom_etiketa = pom_etiketa + "wineId=" + entry.id + "&";

          _this.filterEtiketa =
            _this.filterEtiketa +
            entry.wineLabel.name +
            " " +
            entry.year +
            (entry.wineLabel.inProduction ? ' *' : '') +
            ", ";
        });
      }

      var pom_operation_to_to_select = "";

      this.fiterTipoviVina = "";

      if (this.wt_select !== undefined && this.wt_select !== null) {
        this.wt_select.forEach(function (entry) {
          pom_operation_to_to_select =
            pom_operation_to_to_select + "wineTypeId=" + entry.id + "&";

          _this.fiterTipoviVina = _this.fiterTipoviVina + entry.name + ", ";
        });
      }

      var pom_operacija = "";
      this.filterOperacija = "";

      if (this.actions_select !== undefined && this.actions_select !== null) {
        this.actions_select.forEach(function (entry) {
          pom_operacija =
            pom_operacija +
            "operation=" +
            prevediSveOperacijeSaSrpskog(entry.name) +
            "&";

          _this.filterOperacija = _this.filterOperacija + entry.name + ", ";
        });
      }

      let sortiranje = "";
      if (this.paginationKartica.sortBy !== "") {
        let orderovanje = "";
        if (this.paginationKartica.descending) orderovanje = "desc";
        else orderovanje = "asc";

        sortiranje =
          "sort=" +
          this.paginationKartica.sortBy.replace("documentNumber", "number") +
          "&order=" +
          orderovanje;
      }

      let urlLoc =
        "/tank_phase_wine/outage_sediment_pressing_rest?" +
        pom_operation_to_to_select +
        pom_etiketa +
        pom_operacija;

      if (
        urlLoc.substring(urlLoc.length - 1, urlLoc.length) === "?" ||
        urlLoc.substring(urlLoc.length - 1, urlLoc.length) === "&"
      )
        urlLoc = urlLoc + sortiranje;
      else urlLoc = urlLoc + "&" + sortiranje;

      // urlLoc = urlLoc.substring(0, urlLoc.length - 1);

      let urlFinish;

      if (paginacija) urlFinish = urlLoc + strDate + strDateDo;
      else urlFinish = urlLoc + strDate + strDateDo + "&pageSize=1000000";

      setTimeout(() => {
        this.$http
          .get(this.globalServiceLocation + this.globalPort + urlFinish, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          })
          .then((response) => {
            this.total = {
              rastur: 0,
              talog: 0,
              komina: 0,
            };

            if (paginacija) this.items_states = response.data;

            let _this = this;
            this.json_data = [];
            let rbr = 1;

            this.items_states.forEach(function (entry) {
              _this.total.rastur = _this.total.rastur + entry.outage;
              _this.total.talog = _this.total.talog + entry.sediment;
              _this.total.komina = _this.total.komina + entry.pressingRest;

              let objekat = {
                Rb: rbr,
                Datum: _this.formatDateTime(entry.date),
                Operacija: _this.prevediSveOperacijeLok(entry.operation),
                "Tip vina": entry.wineType,
                Vino: entry.wine + (entry.inProduction ? ' *' : ''),
                Rastur:
                  entry.outage !== null && entry.outage !== 0
                    ? entry.outage + " " + entry.outageUnitOfMeasure
                    : "-",
                Talog:
                  entry.sediment !== null && entry.sediment !== 0
                    ? entry.sediment + " " + entry.sedimentUnitOfMeasure
                    : "-",
                Komina:
                  entry.pressingRest !== null && entry.pressingRest !== 0
                    ? entry.pressingRest + " " + entry.pressingRestUnitOfMeasure
                    : "-",
              };
              _this.json_data.push(objekat);

              rbr = rbr + 1;

              if (sortiranjeOperacije !== undefined)
                entry.operation = _this.prevediSveOperacijeLok(entry.operation);
            });

            this.items_states.sort(function (a, b) {
              const nameA = a.operation.toUpperCase(); // ignore upper and lowercase
              const nameB = b.operation.toUpperCase(); // ignore upper and lowercase
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }

              return 0;
            });

            this.ukupnoRedova = response.data.totalElements;

            let objekatSum = {
              Rb: "",
              Datum: "",
              Operacija: "",
              "Tip vina": "",
              Vino: "Ukupno:",
              Rastur: this.total.rastur > 0 ? this.total.rastur + " l" : "-",
              Talog: this.total.talog > 0 ? this.total.talog + " l" : "-",
              Komina: this.total.komina > 0 ? this.total.komina + " kg" : "-",
            };

            this.json_data.push(objekatSum);

            if (!paginacija) this.stampajSve();
            else this.isLoading = false;
          })
          .catch((e) => {
            if (!e.response) {
              this.isLoading = false;
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          urlFinish,
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        this.total = {
                          rastur: 0,
                          talog: 0,
                          komina: 0,
                        };

                        if (paginacija) this.items_states = response.data;

                        let _this = this;
                        this.json_data = [];
                        let rbr = 1;

                        this.items_states.forEach(function (entry) {
                          _this.total.rastur =
                            _this.total.rastur + entry.outage;
                          _this.total.talog =
                            _this.total.talog + entry.sediment;
                          _this.total.komina =
                            _this.total.komina + entry.pressingRest;

                          let objekat = {
                            Rb: rbr,
                            Datum: _this.formatDateTime(entry.date),
                            Operacija: _this.prevediSveOperacijeLok(
                              entry.operation
                            ),
                            "Tip vina": entry.wineType,
                            Vino: entry.wine + (entry.inProduction ? ' *' : ''),
                            Rastur:
                              entry.outage !== null && entry.outage !== 0
                                ? entry.outage + " " + entry.outageUnitOfMeasure
                                : "-",
                            Talog:
                              entry.sediment !== null && entry.sediment !== 0
                                ? entry.sediment +
                                  " " +
                                  entry.sedimentUnitOfMeasure
                                : "-",
                            Komina:
                              entry.pressingRest !== null &&
                              entry.pressingRest !== 0
                                ? entry.pressingRest +
                                  " " +
                                  entry.pressingRestUnitOfMeasure
                                : "-",
                          };
                          _this.json_data.push(objekat);

                          rbr = rbr + 1;

                          if (sortiranjeOperacije !== undefined)
                            entry.operation = _this.prevediSveOperacijeLok(
                              entry.operation
                            );
                        });

                        this.items_states.sort(function (a, b) {
                          const nameA = a.operation.toUpperCase(); // ignore upper and lowercase
                          const nameB = b.operation.toUpperCase(); // ignore upper and lowercase
                          if (nameA < nameB) {
                            return -1;
                          }
                          if (nameA > nameB) {
                            return 1;
                          }

                          return 0;
                        });

                        this.ukupnoRedova = response.data.totalElements;

                        let objekatSum = {
                          Rb: "",
                          Datum: "",
                          Operacija: "",
                          "Tip vina": "",
                          Vino: "Ukupno:",
                          Rastur:
                            this.total.rastur > 0
                              ? this.total.rastur + " l"
                              : "-",
                          Talog:
                            this.total.talog > 0
                              ? this.total.talog + " l"
                              : "-",
                          Komina:
                            this.total.komina > 0
                              ? this.total.komina + " kg"
                              : "-",
                        };

                        this.json_data.push(objekatSum);

                        if (!paginacija) this.stampajSve();
                        else this.isLoading = false;
                      });
                  });
              } else {
                this.isLoading = false;

                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }, 10);
    },
    clear() {
      

      if (this.$refs.form !== undefined) this.$refs.form.reset();

      this.filterOperacija = "";
      this.filterEtiketa = "";
      this.fiterTipoviVina = "";

      this.datumOdFiter = "";
      this.datumDoFiter = "";

      this.setDate();
    },
    changeSortKartica(column) {
      if (this.items_states.length > 0)
        if (typeof column !== "undefined")
          if (column !== "funkcije")
            if (this.paginationKartica.sortBy === column) {
              this.paginationKartica.descending =
                !this.paginationKartica.descending;
            } else {
              this.paginationKartica.sortBy = column;
              this.paginationKartica.descending = false;
            }
    },
    stampaj() {
      this.getAllVina(false);
    },
    stampajSve() {
      let _this = this;
      this.isLoading = true;

      setTimeout(() => {
        var elementToPrint = document.createElement("div");
        elementToPrint.style.margin = "0px 0px 0px 0px";

        var elementToPrint2 = document.createElement("p");
        elementToPrint2.innerHTML = _this.naslov;

        elementToPrint2.style.position = "relative";
        elementToPrint2.style.textAlign = "center";
        elementToPrint2.style.fontSize = "20px";
        elementToPrint.append(elementToPrint2);

        if (
          _this.datumOdFiter !== "" ||
          _this.datumDoFiter !== "" ||
          _this.filterOperacija !== "" ||
          _this.fiterTipoviVina !== "" ||
          _this.filterEtiketa !== ""
        ) {
          let pomocni_tekst = "";

          if (_this.datumOdFiter !== "" || _this.datumDoFiter !== "") {
            if (_this.datumOdFiter !== "") {
              pomocni_tekst =
                pomocni_tekst +
                "Period: " +
                _this.formatDate1(_this.datumOdFiter) +
                ".";

              if (_this.datumDoFiter !== "")
                pomocni_tekst =
                  pomocni_tekst +
                  " - " +
                  _this.formatDate1(_this.datumDoFiter) +
                  ".";
            } else
              pomocni_tekst =
                pomocni_tekst +
                "Za period do: " +
                _this.formatDate1(_this.datumOdFiter) +
                ".";

            pomocni_tekst = pomocni_tekst + "<br>";
          }

          if (_this.fiterTipoviVina !== "") {
            pomocni_tekst =
              pomocni_tekst +
              "Tipovi vina: " +
              _this.fiterTipoviVina.substring(
                0,
                _this.fiterTipoviVina.length - 2
              );
            pomocni_tekst = pomocni_tekst + "<br>";
          }

          if (_this.filterEtiketa !== "") {
            pomocni_tekst =
              pomocni_tekst +
              "Vino: " +
              _this.filterEtiketa.substring(0, _this.filterEtiketa.length - 2);
            pomocni_tekst = pomocni_tekst + "<br>";
          }

          if (_this.filterOperacija !== "") {
            pomocni_tekst =
              pomocni_tekst +
              "Operacija: " +
              _this.filterOperacija.substring(
                0,
                _this.filterOperacija.length - 2
              );
            pomocni_tekst = pomocni_tekst + "<br>";
          }

          var elementToPrint1 = document.createElement("p");

          elementToPrint1.innerHTML = pomocni_tekst + " <br>";

          elementToPrint1.style.margin = "5px 0px 0px 0px";
          elementToPrint1.style.fontSize = "14px";
          elementToPrint.append(elementToPrint1);
        }

        // var body = document.getElementsByTagName("body")[0];
        var tbl = document.createElement("table");
        var tr = document.createElement("tr"); // Header row
        jQuery.each(_this.json_fields, function (i, val) {
          var th = document.createElement("th"); //column
          var text = "";
          text = document.createTextNode(i);

          th.setAttribute("style", "padding-bottom: 4px;");

          th.appendChild(text);

          tr.appendChild(th);
        });

        tr.style.background = "#eaece5";
        tbl.appendChild(tr);

        var tblBody = document.createElement("tbody");

        let poslednjiRed = null;

        jQuery.each(_this.json_data, function (i, val1) {
          var isLastElement = i == _this.json_data.length - 1;

          var row = document.createElement("tr");

          let pomJ = 0;

          jQuery.each(val1, function (i, val) {
            var cell = document.createElement("td");

            var cellText;

            if ((val === null || val === 0 || val === "") && !isLastElement)
              cellText = document.createTextNode("-");
            else cellText = document.createTextNode(val);

            cell.appendChild(cellText);

            if (i === 1)
              cell.setAttribute(
                "style",
                "text-align :left; padding-left: 5px; padding-bottom: 4px;"
              );
            else if (
              _this.json_fields_type[pomJ] === "Number" ||
              _this.json_fields_type[pomJ] === "StringRight"
            ) {
              cell.setAttribute(
                "style",
                "text-align :right; padding-bottom: 4px; padding-right: 5px;"
              );
            } else if (_this.json_fields_type[pomJ] === "Date") {
              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px; padding-right: 1px; padding-left: 1px;"
              );
            } else
              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px;"
              );

            pomJ = pomJ + 1;

            row.appendChild(cell);
          });

          if (isLastElement) {
            poslednjiRed = row;
            // row.setAttribute("border", "none");
          }

          tblBody.appendChild(row);
        });

        tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        // tbl.style.borderColor = "black";

        tbl.appendChild(tblBody);

        tbl.style.margin = "0px 0px 0px 0px";
        tbl.style.width = "100%";

        elementToPrint.appendChild(tbl);

        // var tbl = document.createElement("table");
        // var tblBody = document.createElement("tbody");

        // tbl.style.margin = "20px 0px 0px 82%";
        // tbl.style.width = "18%";
        // // tbl.setAttribute("border", "thin solid");
        // tbl.style.borderCollapse = "collapse";
        // tbl.appendChild(tblBody);
        // elementToPrint.appendChild(tbl);

        // tblBody.appendChild(poslednjiRed);

        // tbl.appendChild(tblBody);
        // elementToPrint.appendChild(tbl);

        // html2pdf(elementToPrint, {
        //   margin: 1,
        //   filename: item.number + ".pdf",
        //   image: { type: "jpeg", quality: 0.98 },
        //   // html2canvas: { dpi: 192, letterRendering: true },
        //   html2canvas: { dpi: 300, scale: 2 },
        //   jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        // }).then((response) => {
        //   this.isLoading = false;
        // });

        html2pdf(null, {
          margin: 1,
          // filename: item.number + ".pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { dpi: 300, scale: 2 },
          jsPDF: { unit: "cm", format: "a4", orientation: "landscape" },
          // pagebreak: {
          //     mode: ['avoid-all', 'css', 'legacy']
          // }
          pagebreak: { avoid: ["tr", "td"], before: "#nextpage1" },
        })
          .from(elementToPrint)
          .toPdf()
          .get("pdf")
          .then(function (pdf) {
            var totalPages = pdf.internal.getNumberOfPages();
            var i;

            for (i = 1; i <= totalPages; i++) {
              pdf.setPage(i);
              pdf.setFontSize(10);
              pdf.setTextColor(150);
              pdf.text(
                getDateTime(),
                0.9,
                pdf.internal.pageSize.getHeight() - 0.5
              );

              pdf.text(
                i + " od " + totalPages,
                pdf.internal.pageSize.getWidth() / 1.075,
                pdf.internal.pageSize.getHeight() - 0.5
              );
            }
            _this.isLoading = false;

            window.open(pdf.output("bloburl"), "_blank");
          });
      }, 10);
    },
  },
  mounted() {
    this.clear();

    this.getAllWineTypes();

    if (this.items_states.length === 0) this.getAllVina(true);
  },
};
</script>

<style scoped lang='scss'>
@import "./parts/../../assets/sass/parts/modalStyles_siri_modal";

div.layout.row.wrap {
  padding-top: 20px !important;
  max-height: 90px !important;
}

.topics tr {
  line-height: 14px;
}

.topics {
  margin-left: 42%;
  border-collapse: collapse;
  border-spacing: 0;
  width: 58%;
}

.topics th {
  height: 25px;
  font-weight: 500;
  font-size: 12px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
}

.topics td {
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
}

.closeModalInModalBtn {
  position: absolute;
  right: 0;
  top: 0;
}

.menuable__content__active {
  background-color: white;
}

@media print {
  table,
  div {
    break-inside: avoid;
  }
}

thead {
  display: table-header-group;
}
tfoot {
  display: table-row-group;
}
tr {
  page-break-after: always !important;
  page-break-before: always !important;
  page-break-inside: auto !important;
}

div {
  page-break-inside: avoid;
}
#nextpage1 {
  page-break-before: always;
}
</style>